import {PolyNodeController} from './../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeController';
const IS_PROD = process.env.NODE_ENV == 'production';
const API_ROOT_URL = IS_PROD ? '' : 'http://localhost:8091';
export const MARKETPLACE_ROOT = IS_PROD ? `https://market.polygonjs.com/` : 'http://localhost:3000/';

import {StatusCodes} from 'http-status-codes';
import {PluginsRegisterData} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/plugins/PluginsRegister';
import {SceneJsonExporterData} from '../../../@polygonjs/polygonjs/src/engine/io/json/export/Scene';
import {IntegrationData} from '../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {StoreController} from '../store/controllers/StoreController';
import {EditorLayoutData} from '../types';
import {
	LocalServerUrl,
	ResponseMessageFromLocalServer,
	// SceneExportType,
	// ExportTypeRequestBody,
	AssetsRequestQuery,
	ASSETS_EXTENSIONS_SEPARATOR,
	LibrariesInstallQuery,
	LoadSceneQuery,
	// ExportSceneQuery,
	CaptureRequestSaveBody,
	// ExportSceneResponse,
	CaptureRequestSaveResponse,
	CaptureRequestLoadQuery,
	CaptureRequestLoadErrorResponse,
	AssetsRequestResponse,
	StatusQueryResponse,
	SaveResponse,
	PolyNodeCreateResponse,
	PolyNodeUpdateResponse,
	UserDataResponse,
	AssetDownloadRequestBody,
	AssetDownloadRequestResponse,
	MarketplacePolyNodeCreateRequestFromEditorBody,
	MarketplacePolyNodeIndexResponseFromLocal,
	MarketplacePolyNodeSearchRequestFromEditorBody,
	MarketplacePolyNodeDownloadRequestFromEditorBody,
	MarketplacePolyNodeSearchResponseFromServer,
	MarketplacePolyNodeDownloadResponseFromLocal,
} from './NpmModuleTypes';
import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {NpmModuleSceneLoadController} from './SceneLoadController';
import {CoreFileUtils} from '../core/FileUtils';
import {FilesRegister} from '../self_contained/FilesRegister';
import {WindowController} from '../core/WindowController';
import {NpmModuleStatusPingController} from './StatusPing';
import {DateUtils} from '../core/DateUtils';
import {PolyNodeDataRegister} from '../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDataRegister';
import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {ArrayUtils} from '../../../@polygonjs/polygonjs/src/core/ArrayUtils';

export enum SaveWarningResponse {
	SKIP = 'skip',
	SAVE_AGAIN = 'save again',
}

interface LoginCredentials {
	email: string;
	password: string;
}
// interface ExportTypeOptions {
// 	export: SceneExportType;
// }

export interface SceneConfig {
	engine_version: string;
	// editor_version: string;
	name: string;
	code: SceneJsonExporterData;
	layout_data: EditorLayoutData;
	nodes: string[];
	operations: string[];
	modules: string[]; // TODO: could be removed now that modules are not used, but this is kept in case it breaks something in the exporter
	assemblers: string[];
	integrations: IntegrationData[];
	nodes_map: Dictionary<string>;
	plugins_data: PluginsRegisterData;
	poly_nodes: string[];
	assets: string[];
	libsRoot: string;
	assetsRoot: string;
	scenePropTypes: string;
}

// interface BufferJson {
// 	type: 'Buffer';
// 	data: number[];
// }

interface StatusOptions {
	pingCount: number;
}

export class NpmModuleApiController {
	static async create_token(credentials: LoginCredentials) {
		const url = `${API_ROOT_URL}${LocalServerUrl.TOKEN_CREATE}`;
		const data = {email: credentials.email, password: credentials.password};
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(data),
		});
		if (response.status == StatusCodes.OK) {
			// if the response is ok, we can try to save again
			StoreController.editor.dialogApiLogin.setErrorMessage(null);
			StoreController.editor.dialogApiLogin.executeCallback();
			StoreController.editor.dialogApiLogin.hide();
		} else {
			// if the response is not ok, we show the error on the prompt
			const json = await response.json();
			const error: string = json.error;
			StoreController.editor.dialogApiLogin.setErrorMessage(error);
		}
		return response;
	}

	// static async save_export_type(options: ExportTypeOptions) {
	// 	const url = `${API_ROOT_URL}${LocalServerUrl.EXPORT_TYPE_SAVE}`;
	// 	const data: ExportTypeRequestBody = options;
	// 	const response = await fetch(url, {
	// 		method: 'POST',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			Accept: 'application/json',
	// 		},
	// 		body: JSON.stringify(data),
	// 	});
	// 	if (response.status == StatusCodes.OK) {
	// 		// if the response is ok, we can try to save again
	// 		StoreController.editor.dialog_api_export.execute_callback();
	// 		StoreController.editor.dialog_api_export.hide();
	// 	} else {
	// 		// if the response is not ok, we show an alert (but that should be rare, as there only reason it could fail if there is no write permission or the disk is full)
	// 		alert('could not save the export type');
	// 		// const json = await response.json();
	// 		// const error_message: string = json.error;
	// 		// StoreController.editor.dialog_api_export.set_error_message(error_message);
	// 	}
	// 	return response;
	// }

	static async fetch_user_data() {
		const url = `${API_ROOT_URL}${LocalServerUrl.TOKEN_GET}`;
		const response = await fetch(url);

		if (response.status == StatusCodes.OK) {
			const json: UserDataResponse = await response.json();
			StoreController.editor.currentUser.setUsername(json.username);
			StoreController.editor.user_plan.setPro(json.pro);

			// if (process.env.NODE_ENV == 'development') {
			// 	StoreController.editor.marketplacePolyNodes.show();
			// }
		} else {
			const json = await response.json();
			console.warn('login error', json);
			await StoreController.editor.dialogApiLogin.show();
			this.fetch_user_data();
		}
	}

	static load_poly_config_url() {
		// the name cannot be added at the end of this url, as it would not work
		// when used in a <script> tag, with import {X} from '<url>'.
		// Also, for new (unsaved) scenes, the sceneName would be null
		return `${API_ROOT_URL}${LocalServerUrl.POLY_CONFIG_LOAD}`;
		// const response = await fetch(url);
		// return response;
	}
	static load_poly_config_url_raw() {
		return this.load_poly_config_url();
		// const params: PolyConfigQuery = {raw: '1'};
		// return `${API_ROOT_URL}${LocalServerUrl.POLY_CONFIG_LOAD}?raw=${params.raw}`;
		// const response = await fetch(url);
		// return response;
	}
	static load_editor_config_url() {
		return `${API_ROOT_URL}${LocalServerUrl.EDITOR_CONFIG_LOAD}`;
	}
	static async loadSceneExportEngine(sceneName: string) {
		// const params: ExportSceneQuery = {scene: sceneName, minify: '1', gzip: '1', brotli: '1'};
		// const url = `${API_ROOT_URL}${LocalServerUrl.SCENE_EXPORT_ENGINE}?scene=${params.scene}&minify=${params.minify}&gzip=${params.gzip}&brotli=${params.brotli}`;
		// const response = await fetch(url);
		// const json = (await response.json()) as ExportSceneResponse;
		// // uncompressed
		// const uncompressedData = JSON.parse(json.uncompressed);
		// const uncompressedBuffer = Buffer.from(uncompressedData.data);
		// // gzip
		// const gzipData: BufferJson | null = json.gzip.length > 0 ? JSON.parse(json.gzip) : null;
		// // brotli
		// const brotliData: BufferJson | null = json.brotli.length > 0 ? JSON.parse(json.brotli) : null;
		// return {
		// 	uncompressed: uncompressedBuffer,
		// 	gzip: gzipData ? Buffer.from(gzipData.data) : null,
		// 	brotli: brotliData ? Buffer.from(brotliData.data) : null,
		// };
	}
	// static async debug() {
	// 	const json = await this.loadSceneExportEngine('scene_01');
	// 	console.log(json);
	// 	console.log(JSON.parse((json as any).uncompressed));
	// 	const data = JSON.parse((json as any).uncompressed);
	// 	console.log(data);
	// 	const buffer = Buffer.from(data.data);
	// 	console.log(buffer);
	// 	console.log(buffer.toString());
	// 	// console.log(blob, await blob.json(), await blob.arrayBuffer());
	// }

	static async loadSceneNames() {
		const url = `${API_ROOT_URL}${LocalServerUrl.SCENES}`;
		const response = await fetch(url);
		return response;
	}
	static async loadScene(sceneName: string | null) {
		const params: LoadSceneQuery = {scene: sceneName};
		const url = `${API_ROOT_URL}${LocalServerUrl.SCENE_LOAD}?scene=${params.scene}`;
		const response = await fetch(url);
		return response;
	}
	static async loadAssets(extensions: string[]) {
		const params: AssetsRequestQuery = {
			extensionsJoined: ArrayUtils.uniq(extensions).join(ASSETS_EXTENSIONS_SEPARATOR),
		};
		const url = `${API_ROOT_URL}${LocalServerUrl.ASSETS}?extensionsJoined=${params.extensionsJoined}`;
		const response = await fetch(url);
		const json: AssetsRequestResponse = await response.json();
		return json;
	}
	static async downloadAsset(remoteUrl: string) {
		const url = `${API_ROOT_URL}${LocalServerUrl.ASSET_DOWNLOAD}`;
		const data: AssetDownloadRequestBody = {remoteUrl};
		const body = JSON.stringify(data);
		// console.log(body);
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: body,
		});
		const json = (await response.json()) as AssetDownloadRequestResponse;
		return json;
	}
	static async installDraco() {
		return this._installLib(LocalServerUrl.INSTALL_DRACO);
	}
	static async installKTX2() {
		return this._installLib(LocalServerUrl.INSTALL_KTX2);
	}
	static async installXAtlas() {
		return this._installLib(LocalServerUrl.INSTALL_XATLAS);
	}
	private static async _installLib(routeName: string) {
		const libsRoot = Poly.libs.root();
		if (!libsRoot) {
			return;
		}
		const params: LibrariesInstallQuery = {
			libsRoot: libsRoot,
		};
		const url = `${API_ROOT_URL}${routeName}?libsRoot=${params.libsRoot}`;
		const response = await fetch(url);
		return response;
	}

	private static _statusPing = new NpmModuleStatusPingController();
	static async saveScene(scene_config: SceneConfig) {
		if (WindowController.instance().sceneSavingInProgress()) {
			alert('the scene is currently being saved, please wait');
			return;
		}
		WindowController.instance().markSceneSavingInProgress();
		this._statusPing.start();

		const url = `${API_ROOT_URL}${LocalServerUrl.SCENE_SAVE}`;
		const data = {scene_config};
		const body = JSON.stringify(data);
		// console.log(body);
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: body,
		});
		WindowController.instance().markSceneSavingCompleted();
		this._statusPing.end();

		if (response.status == StatusCodes.OK) {
			StoreController.editor.status.setMessage(`scene saved`);

			const json = (await response.json()) as SaveResponse;
			if (json.warning) {
				if (json.warning == ResponseMessageFromLocalServer.NO_NODE_MODULES) {
					const response = await StoreController.editor.saveWarnings.display();
					if (response == SaveWarningResponse.SAVE_AGAIN) {
						setTimeout(() => this.saveScene(scene_config), 200);
						return;
					}
				}
			}

			StoreController.editor.status.setMessage(`✅ scene saved at ${DateUtils.nowHuman()}`);
			NpmModuleSceneLoadController.updateUrl(scene_config.name);
		} else {
			await this._handle_save_scene_error(response, scene_config);
		}

		return true;
	}

	private static async _handle_save_scene_error(response: Response, scene_config: SceneConfig) {
		const json = await response.json();
		const error = json.error;
		switch (error) {
			case ResponseMessageFromLocalServer.NO_USER: {
				await StoreController.editor.dialogApiLogin.show();
				this.saveScene(scene_config);
				break;
			}
			// case ResponseMessageFromLocalServer.NO_EXPORT_TYPE: {
			// 	await StoreController.editor.dialog_api_export.show();
			// 	this.save_scene(scene_config);
			// 	break;
			// }
			default: {
				console.error(error);
				StoreController.editor.status.setError(`failed to save scene (error: ${error})`);
			}
		}
	}
	/*
	 *
	 * POLY NODES
	 *
	 */
	static async polyNodesIndex() {
		// const username = StoreController.editor.currentUser.username().value;
		// if (!username) {
		// 	console.warn('you need to be logged in to fetch polyNodes');
		// 	return;
		// }
		const url = `${API_ROOT_URL}${LocalServerUrl.POLY_NODES_INDEX}`;
		// const urlParams = new URLSearchParams();
		// urlParams.append('username', username);
		// const urlWithQuery = `${url}?${urlParams.toString()}`;
		const response = await fetch(url);
		const json = (await response.json()) as PolyNodeDataRegister<NodeContext>[];
		console.log('polyNodes', json);
		return json;
	}
	static async polyNodeCreate(data: PolyNodeDataRegister<NodeContext>) {
		const url = `${API_ROOT_URL}${LocalServerUrl.POLY_NODE_CREATE}`;
		const body = JSON.stringify(data);
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: body,
		});
		const json = (await response.json()) as PolyNodeCreateResponse;
		return json;
	}
	static async polyNodeUpdate(data: PolyNodeDataRegister<NodeContext>) {
		const url = `${API_ROOT_URL}${LocalServerUrl.POLY_NODE_UPDATE}`;
		const body = JSON.stringify(data);
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: body,
		});
		const json = (await response.json()) as PolyNodeUpdateResponse;
		return json;
	}
	/*
	 *
	 * MARKETPLACE
	 *
	 */
	static async marketplacePolyNodeIndex() {
		const username = StoreController.editor.currentUser.username().value;
		if (!username) {
			console.warn('you need to be logged in to fetch polyNodes');
			return;
		}
		const url = `${API_ROOT_URL}${LocalServerUrl.MARKETPLACE_POLY_NODES_INDEX}`;
		const urlParams = new URLSearchParams();
		urlParams.append('username', username);
		const urlWithQuery = `${url}?${urlParams.toString()}`;
		const response = await fetch(urlWithQuery, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		});
		const json = (await response.json()) as MarketplacePolyNodeIndexResponseFromLocal;
		return json;
	}
	static async marketplacePolyNodeSearch(options: MarketplacePolyNodeSearchRequestFromEditorBody) {
		const url = `${API_ROOT_URL}${LocalServerUrl.MARKETPLACE_POLY_NODES_SEARCH}`;
		const urlWithQuery = `${url}?q=${options.q || ''}`;
		console.log(urlWithQuery);
		const response = await fetch(urlWithQuery, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		});
		const json = (await response.json()) as MarketplacePolyNodeSearchResponseFromServer;
		return json;
	}
	static async marketplacePolyNodeDownload(options: MarketplacePolyNodeDownloadRequestFromEditorBody) {
		const url = `${API_ROOT_URL}${LocalServerUrl.MARKETPLACE_POLY_NODES_DOWNLOAD}`;
		const urlParams = new URLSearchParams();
		urlParams.append('username', options.username);
		urlParams.append('node_context', options.node_context);
		urlParams.append('node_type', options.node_type);
		urlParams.append('version', `${options.version}`);
		const urlWithQuery = `${url}?${urlParams.toString()}`;
		console.log(urlWithQuery);
		const response = await fetch(urlWithQuery, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		});
		const json = (await response.json()) as MarketplacePolyNodeDownloadResponseFromLocal;

		PolyNodeController.createNodeClassAndRegister({
			node_context: options.node_context as NodeContext,
			node_type: options.node_type,
			data: json,
		});

		return json;
	}
	static async marketplacePolyNodeCreate(data: MarketplacePolyNodeCreateRequestFromEditorBody) {
		const url = `${API_ROOT_URL}${LocalServerUrl.MARKETPLACE_POLY_NODES_CREATE}`;

		const body = JSON.stringify(data);
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: body,
		});
		const json = (await response.json()) as PolyNodeCreateResponse;
		return json;
	}

	/*
	 *
	 * VIEWER CAPTURE
	 *
	 */
	static async saveCaptureAnimation(sceneName: string, file: File) {
		const data: CaptureRequestSaveBody = {
			sceneName,
			fileDataURL: await CoreFileUtils.fileToDataURL(file),
		};
		const url = `${API_ROOT_URL}${LocalServerUrl.CAPTURE_ANIMATION_SAVE}`;
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(data),
		});
		if (response.ok) {
			const json = (await response.json()) as CaptureRequestSaveResponse;
			StoreController.editor.status.setMessage(`video saved to ${json.filePath}`);
		} else {
			StoreController.editor.status.setError(`failed to save video`);
		}
	}
	static async saveCaptureStatic(sceneName: string, file: File) {
		const data: CaptureRequestSaveBody = {
			sceneName,
			fileDataURL: await CoreFileUtils.fileToDataURL(file),
		};
		const url = `${API_ROOT_URL}${LocalServerUrl.CAPTURE_STATIC_SAVE}`;
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(data),
		});
		if (response.ok) {
			const json = (await response.json()) as CaptureRequestSaveResponse;
			StoreController.editor.status.setMessage(`image saved to ${json.filePath}`);
		} else {
			StoreController.editor.status.setError(`failed to save static image`);
		}
	}
	static async loadCaptureStatic(sceneName: string) {
		const params: CaptureRequestLoadQuery = {
			sceneName,
		};
		const url = `${API_ROOT_URL}${LocalServerUrl.CAPTURE_STATIC_LOAD}?sceneName=${params.sceneName}`;
		const response = await fetch(url);
		if (response.ok) {
			const blob = await response.blob();
			FilesRegister.setThumbnailStaticBlob(blob);
			// StoreController.editor.status.setMessage(`image saved to ${json.filePath}`);
		} else {
			const json = (await response.json()) as CaptureRequestLoadErrorResponse;
			console.warn(json.error);
			// StoreController.editor.status.setError(`failed to load static image`);
		}
	}
	static async getStatus(options: StatusOptions) {
		const url = `${API_ROOT_URL}${LocalServerUrl.STATUS}?ping=${options.pingCount}`;
		const response = await fetch(url);
		const json: StatusQueryResponse = await response.json();
		return json.status;
	}

	static async logout() {
		const url = `${API_ROOT_URL}${LocalServerUrl.LOGOUT}`;
		await fetch(url, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		});
		location.reload();
	}
}
